/* eslint-disable max-len */
import React from 'react';
import './index.scss';

export default () => {
  return (
    <div data-testid="babbel-loader" className="babbel-loader">
      <div className="babbel-loader__brand">
        <svg viewBox="0 0 16 16">
          <path d="M10.7599332,0.789821454 C10.465468,0.312666948 9.91728697,0 9.26321743,0 C8.47797705,0 7.76204009,0.452129903 7.41641535,1.09292844 C7.29892673,1.30718403 7.22694637,1.53887249 7.20166401,1.78883734 L7,3.98425418 C7,3.98425418 7.78048134,4 8.13027024,4 C10.9880693,4 10.9925309,1.78883734 10.9925309,1.78883734 C11.0258441,1.41206242 10.9476175,1.08027555 10.7599332,0.789821454 Z" />
          <path d="M14.1386934,6 L2.21337695,6 C1.78618717,6 1.39818035,6.11665607 1.05190496,6.3439288 C0.477858741,6.7072473 0.0697825984,7.3245391 0.00766327924,8.02193261 C-0.0646499795,8.86268277 0.381016316,9.58328036 1.08216822,9.88906548 C1.31503603,9.98982835 1.57498149,10.0499046 1.85786331,10.0499046 L5.79463534,10.0499046 L5.45058988,13.9717101 C5.42637928,14.2565162 5.45504973,14.5178004 5.53914973,14.7638271 C5.7844414,15.4895105 6.46042702,16 7.29983423,16 C8.11949068,16 8.86619676,15.5076287 9.24719525,14.8099174 C9.3883176,14.5546726 9.48070018,14.2778131 9.50586646,13.9717101 L9.85054905,10.0499046 L13.7854097,10.0499046 C14.0698843,10.0499046 14.3355639,9.98982835 14.588501,9.89129053 C15.342534,9.58328036 15.9172173,8.86268277 15.9923976,8.02193261 C16.0631181,7.20406866 15.6343355,6.50254291 14.9605798,6.18563255 C14.7159253,6.0661157 14.4445116,6 14.1386934,6 Z" />
        </svg>
      </div>
      <div className="babbel-loader__rotate">
        <svg className="babbel-loader__spinner" viewBox="0 0 50 50">
          <circle
            className="full-path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="3"
          />
          <circle
            className="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="3"
          />
        </svg>
      </div>
    </div>
  );
};
